<div class="addr-tooltip" *ngIf="displayTooltip"
  [ngClass]="{'top-center': arrowPosition == tooltipArrowPos.TopCenter, 'top-left': arrowPosition == tooltipArrowPos.TopLeft,
  'top-right': arrowPosition == tooltipArrowPos.TopRight, 'bottom-left': arrowPosition == tooltipArrowPos.BottomLeft,
   'bottom-right': arrowPosition == tooltipArrowPos.BottomRight, 'bottom-center': arrowPosition == tooltipArrowPos.BottomCenter }">

  <div class="image-container" *ngIf="mascot">
    <img [src]="mascot" alt="mascot">
  </div>

  <i [class]="icon" *ngIf="icon"></i>

  <span class="tooltip-msg">{{message | translate}}</span>

  <app-button class="tooltip-button" [textButton]="true" (onClickEvent)="closeTooltip()" [buttonName]="button"
    *ngIf="button"></app-button>

  <button type="button" class="tooltip-close" [attr.aria-label]="'button.close' | translate"
    (click)="$event.stopPropagation(); closeTooltip()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
